import OrderDetails from './OrderDetails'
import './OrderDetails.css'

export default OrderDetails



// WEBPACK FOOTER //
// ./src/features/OrderDetails/containers/OrderDetails/index.js